module.exports = __webpack_public_path__ + "img/category-casino.d96a1fee.png";